import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { getHighestUserRole } from 'lib-shared-user-role';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { BanUnbanContactAction } from './components/banUnbanContactAction/banUnbanContactAction';
import { EditContactAction } from './components/editContactAction/editContactAction';
import { MergeContactsAction } from './components/mergeContactsAction/mergeContactsAction';
/** More dropdown with hidden actions */
export const MoreDropdownAction = ({ user, }) => {
    const { mergeContacts } = useFeatureFlag(['merge-contacts']);
    return (_jsx(DropdownButton, { "data-testid": "contact-more-dropdown", icon: "dots-v", buttonProps: {
            variant: 'tertiary',
        }, dropdownProps: {
            closeOnBlur: true,
        }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsxs(ButtonList, { children: [_jsx(EditContactAction, { user: user, toggleDropdown: toggleDropdown }), mergeContacts && (_jsx(MergeContactsAction, { user: user, toggleDropdown: toggleDropdown })), getHighestUserRole(user.roles) === 'enduser' && (_jsx(BanUnbanContactAction, { user: user, toggleDropdown: toggleDropdown }))] })) }) }));
};
